import React__default from 'react';
import SvgIcon from '../../node_modules/@mui/material/SvgIcon/SvgIcon.esm.js';

const SearchBarLocationIcon = (props) => (React__default.createElement(SvgIcon, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 12.861, height: 15.719, viewBox: "272 176.246 18 15" }, props),
    React__default.createElement("path", { stroke: "#11245A", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M286.736 182.676c0 4.288-6.431 9.289-6.431 9.289s-6.43-5.001-6.43-9.289c0-3.502 2.928-6.43 6.43-6.43 3.503 0 6.431 2.928 6.431 6.43Z", style: {
            fill: 'transparent'
        } }),
    React__default.createElement("path", { stroke: "#11245A", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M280.305 184.82a2.143 2.143 0 1 0 0-4.287 2.143 2.143 0 0 0 0 4.287Z", style: {
            fill: 'transparent'
        } })));

export { SearchBarLocationIcon as default };
